import { render, staticRenderFns } from "./RoundName.vue?vue&type=template&id=40b1a719&"
import script from "./RoundName.vue?vue&type=script&lang=js&"
export * from "./RoundName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40b1a719')) {
      api.createRecord('40b1a719', component.options)
    } else {
      api.reload('40b1a719', component.options)
    }
    module.hot.accept("./RoundName.vue?vue&type=template&id=40b1a719&", function () {
      api.rerender('40b1a719', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff-engagement/components/RoundName.vue"
export default component.exports